// Production configuration
export const PRODUCTION_CONFIG = {
  // API Configuration
  // Empty string (LAN build) means same origin: nginx proxies /api to the local backend.
  // API_URL: process.env.REACT_APP_API_URL ?? 'https://api.event.nextwavesaas.tech',
  API_URL: process.env.REACT_APP_API_URL ?? 'https://api.generic.nextwavesaas.tech',

  // API_URL: process.env.REACT_APP_API_URL || 'http://localhost:8080', //  /Users/manishaggarwal/personal/NextWaveProject/event-registration-app backend repo at

  DEMO_MODE: process.env.REACT_APP_DEMO_MODE === 'true',
  
  // Security
  JWT_STORAGE_KEY: 'eventreg_auth_token',
  SESSION_TIMEOUT: 24 * 60 * 60 * 1000, // 24 hours
  
  // Performance
  API_TIMEOUT: 10000, // 10 seconds
  RETRY_ATTEMPTS: 3,
  RETRY_DELAY: 1000, // 1 second
  
  // Feature Flags
  ENABLE_ANALYTICS: process.env.REACT_APP_ENABLE_ANALYTICS === 'true',
  ENABLE_ERROR_REPORTING: process.env.REACT_APP_ENABLE_ERROR_REPORTING === 'true',

  // Cashfree.js mode — backend holds partner keys; FE only needs sandbox|production for the SDK
  CASHFREE_MODE: process.env.REACT_APP_CASHFREE_MODE || 'sandbox',

  
  // Monitoring
  GOOGLE_ANALYTICS_ID: process.env.REACT_APP_GOOGLE_ANALYTICS_ID,
  SENTRY_DSN: process.env.REACT_APP_SENTRY_DSN,
  
  // File Upload
  MAX_FILE_SIZE: 10 * 1024 * 1024, // 10MB
  ALLOWED_FILE_TYPES: ['image/jpeg', 'image/png', 'image/gif', 'application/pdf'],
  
  // Pagination
  DEFAULT_PAGE_SIZE: 10,
  MAX_PAGE_SIZE: 100,
  
  // Cache
  CACHE_DURATION: 5 * 60 * 1000, // 5 minutes
};

// Security utilities
export const SecurityUtils = {
  sanitizeInput: (input) => {
    if (typeof input !== 'string') return input;
    return input.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '');
  },
  
  validateEmail: (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  },
  
  validatePassword: (password) => {
    return password && password.length >= 6;
  },
  
  generateSecureId: () => {
    return Math.random().toString(36).substr(2, 9) + Date.now().toString(36);
  }
};

// Performance utilities
export const PerformanceUtils = {
  debounce: (func, wait) => {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  },
  
  throttle: (func, limit) => {
    let inThrottle;
    return function() {
      const args = arguments;
      const context = this;
      if (!inThrottle) {
        func.apply(context, args);
        inThrottle = true;
        setTimeout(() => inThrottle = false, limit);
      }
    };
  }
};
